import { Component } from "@angular/core";

@Component({
  selector: "oz-software-settings",
  templateUrl: "./device-software-settings.component.pug",
})
export class DeviceSoftwareSettingsComponent {}
